export default Object.freeze({
  WAITING: {
    name: 'waiting',
    displayName: '待機中',
  },
  SEARCHING: {
    name: 'searching',
    displayName: 'マッチング相手を探し中',
  },
  MATCHING: {
    name: 'matching',
    displayName: 'マッチング済み',
  },
  MEETING: {
    name: 'meeting',
    displayName: '調整中',
  },
  WORKING: {
    name: 'working',
    displayName: '作業中',
  },
  WAITING_FOR_PAYMENT: {
    name: 'waitingForPayment',
    displayName: '支払い待ち',
  },
  INSPECTION: {
    name: 'inspecting',
    displayName: '検査中',
  },
  COMPLETION: {
    name: 'completion',
    displayName: '完了',
  },
  MISSING: {
    name: 'missing',
    displayName: 'マッチング失敗',
  },
  ACCEPT: {
    name: 'accept',
    displayName: '承諾',
  },
  REJECT: {
    name: 'reject',
    displayName: '拒否',
  },
});